// Shared constants and utilities for admin dashboard
export const API_URL = (() => {
  // Check for environment variable first
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // In production, use the same origin (backend served from same domain)
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    // If we're on a custom domain (not localhost), use same origin
    if (!currentOrigin.includes('localhost') && !currentOrigin.includes('127.0.0.1')) {
      return currentOrigin;
    }
  }
  
  // Fallback for development
  return 'http://localhost:8001';
})();

export const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4, ease: 'easeOut' },
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'completed':
    case 'succeeded':
    case 'won':
    case 'processed':
      return 'bg-green-100 text-green-800';
    case 'pending':
    case 'pending_approval':
    case 'requested':
    case 'open':
    case 'under_review':
      return 'bg-yellow-100 text-yellow-800';
    case 'processing':
      return 'bg-blue-100 text-blue-800';
    case 'failed':
    case 'lost':
    case 'cancelled':
      return 'bg-red-100 text-red-800';
    case 'draft':
      return 'bg-gray-100 text-gray-800';
    case 'needs_response':
    case 'warning_closed':
      return 'bg-orange-100 text-orange-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleString();
};

export const formatCurrency = (amount, currency = 'USD') => {
  if (amount == null) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};
